import { DialogOptions, useDialog } from './useDialog2';

export function usePresetDialogs() {
  const { showDialog, DialogComponent } = useDialog();

  const showInfo = (message: string, title = 'Інформація') =>
    showDialog({
      title,
      message,
      buttons: [{ label: 'OK', value: true, color: 'primary', autoFocus: true }],
    });

  const showConfirm = (message: string, title = 'Підтвердження') =>
    showDialog({
      title,
      message,
      buttons: [
        { label: 'Так', value: true, color: 'primary' },
        { label: 'Ні', value: false, color: 'error' },
      ],
    });

  const showPrompt = (message: string, defaultValue = '', title = 'Введіть дані') =>
    showDialog({
      title,
      message,
      input: true,
      defaultValue,
      buttons: [
        { label: 'Відмінити', value: null, color: 'error' },
        { label: 'OK', value: 'ok', color: 'primary', autoFocus: true },
      ],
    });

  const showPromptExt = (
    message: string, 
    defaultValue = '', 
    title = 'Введіть дані',
    isValid?: (body: string) => boolean | Promise<boolean>
  ) =>
    showDialog({
      title,
      message,
      input: true,
      defaultValue,
      isValid,
      buttons: [
        { label: 'Відмінити', value: null, color: 'error' },
        { label: 'OK', value: 'ok', color: 'primary', autoFocus: true },
      ],
    });

  const showOptions = <T,>(message: string, options: T[], title = 'Виберіть варіант') =>
    showDialog({
      title,
      message,
      buttons: options.map((opt) => ({ label: String(opt), value: opt })),
    });

  return { showInfo, showConfirm, showPrompt, showPromptExt, showOptions, DialogComponent };
}
